import { Box, CssGrid, Text } from "designSystem/index";
import { STANDARD_BORDER_STYLE } from "designSystem/styles/style-functions";
import React, { useState } from "react";

interface CardProps {
	n: number;
}

const Card = (props: CardProps) => {
	const { n } = props;
	const h = 30 + Math.trunc(50 * Math.random());

	return (
		<Box
			bgcolor="background.paper"
			border={STANDARD_BORDER_STYLE}
			height={h}
			p={2}
		>
			<Text text={`Card ${n}`} />
		</Box>
	);
};

export default () => {
	const [pages, setPages] = useState(1);
	const children = [];

	const onMoreResults = () => {
		setPages(pages + 1);
		console.log("add page: ", pages);
	};

	for (let i = 0; i < 20 * pages; ++i) {
		children.push(<Card key={i} n={i} />);
	}

	return (
		<CssGrid
			columns={1}
			hasMoreResults={pages < 5}
			infiniteScrollRows={5}
			infiniteScrolling
			onMoreResults={onMoreResults}
			spacing={1}
		>
			{children}
		</CssGrid>
	);
};